@if (Trailers().length) {
  <section [class]="{ 'sheyda-row': true, 'show-row': showRow() }">
    <div class="sheyda-row-header">
      <div class="title-bar-title">
        <h3>تریلرها</h3>
      </div>
    </div>
    <div class="navigation-wrapper">
      @if (generalService.isSmallScreen()) {
        <div class="mobile-slider">
          @for (item of Trailers(); track $index) {
            <div class="tam-item mobile-slider-item">
              <a class="tam-item-image" routerLink="/pr/{{ item?.id }}">
                <app-image-generator
                  [sizes]="trailerSizes"
                  [src]="item!.coverImagePath"
                  [name]="item!.title"
                  imageType="landscape"
                />
                <app-icon-button class="tam-play-button" Icon="play_arrow" Appearance="secondary" [IsFillIcon]="true" />
              </a>
              <div class="tam-info-box">
                <h4 class="tam-info-title">{{ item?.title }}</h4>
              </div>
            </div>
          }
        </div>
      } @else {
        <div class="desktop-slider">
          <div class="keen-slider keen-slider--vertical" #desktopSliderRef>
            @for (item of Trailers(); track $index) {
              <div class="tam-item keen-slider__slide">
                <a class="tam-item-image" routerLink="/pr/{{ item?.id }}">
                  <app-image-generator
                    [sizes]="trailerSizes"
                    [src]="item!.coverImagePath"
                    [name]="item!.title"
                    imageType="landscape"
                  />
                  <app-icon-button
                    class="tam-play-button"
                    Icon="play_arrow"
                    Appearance="secondary"
                    [IsFillIcon]="true"
                  />
                </a>
                <div class="tam-info-box">
                  <h4 class="tam-info-title">{{ item?.title }}</h4>
                </div>
              </div>
            }
          </div>
          @if (Trailers().length > itemsPerView()) {
            <button
              aria-label="right"
              [class]="{ 'navigation-button': true, 'prev-slide-button': true, __disabled: currentSlide() === 0 }"
              (click)="prevSlide()"
              [disabled]="currentSlide() === 0"
            >
              <mat-icon>chevron_right</mat-icon>
            </button>
            <button
              aria-label="left"
              (click)="nextSlide()"
              [disabled]="Trailers().length - itemsPerView() === currentSlide()"
              [class]="{
                'navigation-button': true,
                'next-slide-button': true,
                __disabled: Trailers().length - itemsPerView() === currentSlide(),
              }"
            >
              <mat-icon>chevron_left</mat-icon>
            </button>
          }
        </div>
      }
    </div>
  </section>
}
